import { SxProps } from '@mui/material'

export default {
  container: {
    margin: '0 auto',
  },
  titleContainer: {
    marginBottom: 3,
    textAlign: 'center',
  },
  serviceContainer: {
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    gap: 6,
    py: 6,

    '& > *': {
      flex: 1,
    },
  },
} satisfies SxProps
